import React, { useState, useEffect, useRef } from 'react';
import { Menu, X } from '../Icons';
import './NavBar.css';

export const NavBar = () => {
  const [showNavBar, setShowNavBar] = useState(true);
  const lastScrollYRef = useRef(0);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  // Simple throttle for scroll performance (B-01)
  const isThrottled = useRef(false);
  const handleScroll = () => {
    if (isThrottled.current) return;
    isThrottled.current = true;
    
    setTimeout(() => {
      const currentScrollY = window.scrollY;
      setShowNavBar(lastScrollYRef.current > currentScrollY || currentScrollY < 10);
      lastScrollYRef.current = currentScrollY;
      isThrottled.current = false;
    }, 100);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu((prev) => !prev);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setShowMobileMenu(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!showMobileMenu) {
      document.body.style.overflow = '';
      return undefined;
    }

    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [showMobileMenu]);

  return (
    <>
      <div className={`container-nav ${showNavBar ? 'visible' : 'hidden'}`}>
        <div className="container-nav-content">
          <div className="container-nav-title">
            <h1>
              <span className="nav-angle">&lt;/</span>Agustin
              <span className="nav-angle">&gt;</span>
            </h1>
          </div>
          <nav className="container-nav-list" aria-label="Navegación principal">
            <ul>
              <li>
                <button type="button" onClick={() => scrollToSection('about')}>Sobre mí</button>
              </li>
              <li>
                <button type="button" onClick={() => scrollToSection('projects')}>Proyectos</button>
              </li>
              <li>
                <button type="button" onClick={() => scrollToSection('contact')}>Contacto</button>
              </li>
            </ul>
          </nav>
          <div className="container-nav-mobile">
            <button
              type="button"
              onClick={toggleMobileMenu}
              aria-label={showMobileMenu ? 'Cerrar menú principal' : 'Abrir menú principal'}
              className={`burger-button ${showMobileMenu ? 'open' : ''}`}
            >
              {showMobileMenu ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>
      </div>

      <div className={`container-nav-mobile-menu ${showMobileMenu ? 'open' : ''}`}>
        <nav aria-label="Navegación móvil">
          <ul>
            <li>
              <button type="button" onClick={() => scrollToSection('about')}>Sobre mí</button>
            </li>
            <li>
              <button type="button" onClick={() => scrollToSection('projects')}>Proyectos</button>
            </li>
            <li>
              <button type="button" onClick={() => scrollToSection('contact')}>Contacto</button>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};
